<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Service from "./Service";
import Parts from "./Parts";

/**
 * Starter component
 */
export default {
  page: {
    title: "Servis",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Service,
    Parts
  },

  computed: {
    title() {
      return "Pemeliharaan Kendaraan";
    },
  }
};
</script>
      
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">Mengelola data pemeliharaan kendaraan pada perusahaan</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            @click="$router.go(-1)"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>
    </div>

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted">
          <Service status="Service" ref="service" />
          <Parts status="Parts" ref="parts" />
        </b-tabs>
      </b-card>
    </form>

  </Layout>
</template>